import { AxiosError, isAxiosError } from 'axios'
import { z, ZodType } from 'zod'

import { ERROR_MESSAGE } from '@/config/http/http.constants'
import { ApiBusinessDayResponse } from '@/ducks/account/account.schema'

export type IError = {
  store_aquisition_url?: string
  error_flag?: number
  errors?: string
  message: string
  status?: string
  cityBusinessHours?: z.infer<typeof ApiBusinessDayResponse>[]
}

export const isErrorType = (arg: unknown): arg is IError =>
  !!arg && typeof arg === 'object' && 'message' in arg

export function shapeError(error: unknown): IError {
  if (isAxiosError(error)) {
    const axiosError = error as AxiosError<IError>

    const data = axiosError.response?.data
    const status = axiosError.response?.status
    if (typeof data === 'string')
      return { message: data, status: status?.toString() }
    if (!data) return { message: ERROR_MESSAGE, status: status?.toString() }
    if (data.errors)
      return { ...data, message: data.errors, status: (data as IError).status || status?.toString() }
    if (data.message) return { ...data, status: (data as IError).status || status?.toString() }
  }

  if (error instanceof Error) return { message: error.message }

  if (isErrorType(error)) return error

  return { message: 'An unexpected error occurred' }
}

export const responseDataHasError = (data: Record<keyof any, unknown>) => {
  if (!data || typeof data !== 'object') return

  return (
    'error_flag' in data ||
    'errors' in data ||
    (data?.status && data.status === 0)
  )
}

const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string
export function parseResponse<T>(data: any, schema: ZodType<T>): T {
  if (ENVIRONMENT === 'development') {
    return schema.parse(data)
  } else {
    return data
  }
}
